import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path = '', keywords = '' }) => {
  const siteUrl = 'https://federaltrademarkexperts.com';
  const fullTitle = title
    ? `${title} | Federal Trademark Experts`
    : 'Federal Trademark Experts | Trademark Registration & IP Protection';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={`${siteUrl}${path}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${siteUrl}${path}`} />
    </Helmet>
  );
};

export default SEO;
